import Color from "@rakuten/common-util/color";

// base colors as `Color` objects, used to derive colors with `lightness`,
// `saturation`, or `withAlpha`
const black       = new Color(0, 0, 0);
const white       = new Color(255, 255, 255);
const red         = new Color(255, 0, 0);
const blue        = new Color(0, 0, 255);
const yellow      = new Color(255, 255, 0);
const newBlue     = new Color(10, 89, 198);

const colorPalette = {

  black:             black.toString(),
  black04:           black.withAlpha(0.04).toString(),
  black12:           black.withAlpha(0.12).toString(),
  black14:           black.withAlpha(0.14).toString(),
  black16:           black.withAlpha(0.16).toString(),
  black20:           black.withAlpha(0.20).toString(),
  black42:           black.withAlpha(0.42).toString(),
  black65:           black.withAlpha(.65).toString(),

  transparent:       white.withAlpha(0).toString(),
  white:             white.withoutAlpha().toString(),
  white04:           white.withAlpha(.04).toString(),
  white08:           white.withAlpha(0.08).toString(),
  white24:           white.withAlpha(0.24).toString(),
  white32:           white.withAlpha(.32).toString(),
  white48:           white.withAlpha(0.48).toString(),
  white50:           white.withAlpha(0.50).toString(),
  white67:           white.withAlpha(.67).toString(),
  white75:           white.withAlpha(0.75).toString(),

  red:               red.toString(),
  blue:              blue.toString(),
  yellow:            yellow.toString(),
  newBlue:           newBlue.toString(),

//highlight colors
highlightYellowLight:   "#F6F3B3",             //rgb(246,243,179)
highlightBlueLight:   "#B2E1E8",               //rgb(178,225,232)
highlightGreenLight:   "#C6E09E",              //rgb(198,224,158)
highlightPinkLight:   "#E8AFCF",               //rgb(232,175,207)
highlightYellowBgDark:   "#897A36",            //rgba(137,122,54,1)
highlightBlueBgDark:   "#20707D",              //rgba(32,112,125,1)
highlightGreenBgDark:   "#5B7B28",             //rgba(91,123,40,1)
highlightPinkBgDark:   "#99537A",              //rgba(153,83,122,1)
highlightYellowDark:   "#ADA789",              //rgb(173,167,137)
highlightBlueDark:   "#82A1A6",                //rgb(130,161,166)
highlightGreenDark:   "#9AA589",               //rgb(154,165,137)
highlightPinkDark:   "#B999AB"                 //rgb(185,153,171)
};

export default colorPalette;
